import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=09d6e576&scoped=true&"
import script from "./Commande.vue?vue&type=script&lang=ts&"
export * from "./Commande.vue?vue&type=script&lang=ts&"
import style0 from "./Commande.vue?vue&type=style&index=0&id=09d6e576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6e576",
  null
  
)

export default component.exports